/** Default destination after login and after onboarding completes. */
export const POST_AUTH_LANDING_PATH = '/home';

const PATHS_THAT_USE_DEFAULT_LANDING = new Set([
  '/',
  '/sign-in',
  '/sign-up',
  '/email-landing',
  '/email-sign-in',
  '/email-sign-up',
  '/auth-redirect',
]);

/** Keep deep links (ticker, screener, etc.); send marketing/auth paths to the app landing. */
export function resolvePostAuthRedirectPath(
  redirectUrl: string | null | undefined,
): string {
  if (!redirectUrl) {
    return POST_AUTH_LANDING_PATH;
  }

  const pathname = redirectUrl.split('?')[0];
  if (PATHS_THAT_USE_DEFAULT_LANDING.has(pathname)) {
    return POST_AUTH_LANDING_PATH;
  }

  return redirectUrl;
}
